import CustomCursor from "custom-cursor.js";
export const customCursor = () => {
   const proudSwitchers = document.querySelector(".proud__switchers");
   if (proudSwitchers) return;

   const cursorText = document.querySelector(".cursor__text");
   const customCursor = new CustomCursor('.cursor', {
      focusElements: [
         {
            elements: '.result',
            focusClass: '--reel-open',
            mouseenter: () => {
               cursorText.textContent = cursorText.getAttribute("data-reel-open");
            },
            mouseleave: () => {
               cursorText.textContent = "";
            },
         },
         {
            elements: '.result-full .v-overlay',
            focusClass: '--reel-close',
            mouseenter: () => {
               cursorText.textContent = cursorText.getAttribute("data-reel-close");
            },
            mouseleave: () => {
               cursorText.textContent = "";
            },
         },
         {
            elements: '.create-item__image',
            focusClass: '--default',
            mouseenter: () => {
               cursorText.textContent = cursorText.getAttribute("data-default");
            },
            mouseleave: () => {
               cursorText.textContent = "";
            },
         },

         'button',
         'a',
      ],
      focusClass: 'cursor--focused',
   });
   customCursor.initialize();
};
